export default {
  SET_USER(state, data) {
    state.user = data;
  },
  SET_ITEM(state, data) {
    state.item = data;
  },
  SET_LIST(state, data) {
    state.list = data;
  },
};
